import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function JoinPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  const [status, setStatus] = useState('loading');
  const [teamName, setTeamName] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleLocalJoin = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const myUniversity = currentUser.university || '';
    const uid = String(currentUser.userId || currentUser.id);

    let foundTeam = null;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith('allTeams_')) {
        try {
          const teams = JSON.parse(localStorage.getItem(key) || '[]');
          const team = teams.find(t => t.inviteCode === code);
          if (team) { foundTeam = team; break; }
        } catch (e) {}
      }
    }

    if (!foundTeam) { setStatus('not_found'); return; }

    setTeamName(foundTeam.projectTitle || foundTeam.name);

    if (foundTeam.creatorUniversity && myUniversity && foundTeam.creatorUniversity !== myUniversity) {
      setStatus('wrong_school');
      return;
    }

    const myTeams = JSON.parse(localStorage.getItem(`allTeams_${uid}`) || '[]');
    if (myTeams.some(t => t.inviteCode === code)) {
      setStatus('already');
      return;
    }

    myTeams.push({
      ...foundTeam,
      members: [
        ...(foundTeam.members || []).map(m => ({
          ...m,
          isLeader: m.isLeader === true || m.isLeader === 'true' || false,
        })),
        { name: currentUser.name, role: '팀원', isLeader: false, task: '할 일을 등록하세요', contribution: 0 }
      ]
    });
    localStorage.setItem(`allTeams_${uid}`, JSON.stringify(myTeams));
    setStatus('success');
  };

  useEffect(() => {
    if (!code) { setStatus('not_found'); return; }

    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const userId = currentUser.userId || currentUser.id;
    if (!userId) { navigate('/'); return; }

    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';

    fetch(`${apiUrl}/api/teams/join/${userId}?inviteCode=${code}`, {
      method: 'POST'
    })
      .then(async res => {
        const data = await res.json();
        if (res.ok) {
          setTeamName(data.name);
          const uid = String(userId);
          const myTeams = JSON.parse(localStorage.getItem(`allTeams_${uid}`) || '[]');
          const alreadyIn = myTeams.some(t => String(t.id) === String(data.id));
          if (!alreadyIn) {
            // 초대한 팀장 팀의 원본 데이터 찾기
            let originalTeam = null;
            for (let i = 0; i < localStorage.length; i++) {
              const key = localStorage.key(i);
              if (key?.startsWith('allTeams_')) {
                try {
                  const teams = JSON.parse(localStorage.getItem(key) || '[]');
                  const found = teams.find(t => String(t.id) === String(data.id));
                  if (found) { originalTeam = found; break; }
                } catch (e) {}
              }
            }
            myTeams.push({
              id: data.id,
              name: data.name,
              projectTitle: data.name,
              progress: originalTeam?.progress || 0,
              status: originalTeam?.status || '준비',
              deadline: originalTeam?.deadline || '2026-12-31',
              inviteCode: code,
              members: [
                ...(originalTeam?.members || []).map(m => ({
                  ...m,
                  isLeader: m.isLeader === true || m.isLeader === 'true' || false,
                })),
                { name: currentUser.name, role: '팀원', isLeader: false, task: '할 일을 등록하세요', contribution: 0 }
              ],
              feeds: originalTeam?.feeds || [],
              meetingMinutes: originalTeam?.meetingMinutes || []
            });
            localStorage.setItem(`allTeams_${uid}`, JSON.stringify(myTeams));
          }
          setStatus('success');
        } else {
          if (data === '같은 학교 팀원만 초대할 수 있습니다.') {
            setStatus('wrong_school');
          } else if (data === '이미 팀원입니다.') {
            setStatus('already');
          } else {
            handleLocalJoin();
          }
        }
      })
      .catch(() => {
        handleLocalJoin();
      });
  }, [code]);

  const containerStyle = {
    minHeight: '100vh', backgroundColor: '#F0F2F5',
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    fontFamily: 'Pretendard, sans-serif'
  };
  const cardStyle = {
    backgroundColor: '#fff', padding: '60px', borderRadius: '30px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.1)', textAlign: 'center',
    maxWidth: '480px', width: '90%'
  };
  const btnStyle = {
    marginTop: '30px', padding: '15px 40px', backgroundColor: '#4A90E2',
    color: '#fff', border: 'none', borderRadius: '15px', fontSize: '16px',
    fontWeight: '800', cursor: 'pointer'
  };

  const renderContent = () => {
    switch (status) {
      case 'loading':
        return <><div style={{ fontSize: '60px' }}>⏳</div><h2>초대 링크 확인 중...</h2></>;
      case 'success':
        return (
          <>
            <div style={{ fontSize: '60px' }}>🎉</div>
            <h2 style={{ color: '#27AE60' }}>팀 합류 완료!</h2>
            <p style={{ color: '#666', fontSize: '16px' }}><strong>{teamName}</strong> 팀에 성공적으로 합류했어요!</p>
            <button style={btnStyle} onClick={() => navigate('/team-project')}>팀플 관리로 이동</button>
          </>
        );
      case 'wrong_school':
        return (
          <>
            <div style={{ fontSize: '60px' }}>🚫</div>
            <h2 style={{ color: '#EF4444' }}>합류 불가</h2>
            <p style={{ color: '#666', fontSize: '16px' }}>같은 학교 팀원만 초대할 수 있어요.</p>
            <button style={{ ...btnStyle, backgroundColor: '#888' }} onClick={() => navigate('/main')}>메인으로 돌아가기</button>
          </>
        );
      case 'not_found':
        return (
          <>
            <div style={{ fontSize: '60px' }}>❓</div>
            <h2 style={{ color: '#888' }}>유효하지 않은 링크</h2>
            <p style={{ color: '#666', fontSize: '16px' }}>{errorMsg || '초대 링크가 올바르지 않거나 만료되었어요.'}</p>
            <button style={{ ...btnStyle, backgroundColor: '#888' }} onClick={() => navigate('/main')}>메인으로 돌아가기</button>
          </>
        );
      case 'already':
        return (
          <>
            <div style={{ fontSize: '60px' }}>✅</div>
            <h2 style={{ color: '#4A90E2' }}>이미 팀원이에요!</h2>
            <p style={{ color: '#666', fontSize: '16px' }}>이미 이 팀에 참여 중이에요.</p>
            <button style={btnStyle} onClick={() => navigate('/team-project')}>팀플 관리로 이동</button>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>{renderContent()}</div>
    </div>
  );
}

export default JoinPage;